import { configuration } from './Configuration';

/**
 * Hält das Datei-Session-Cookie der API im Takt mit dem Zugriffstoken.
 *
 * `GET /documents/…` ist die allgemeine Datei-Route (Logos, Fotos, Grundrisse, erzeugte Dateien,
 * Konversationsdokumente). Ein `<img>`, ein neuer Tab oder ein iframe kann keinen
 * Authorization-Header senden — deshalb setzt tri-server auf `POST /auth/file-session` ein
 * HttpOnly-Cookie mit demselben Token, und die Route liest es (tri-server
 * docs/documents-route-access.md). Gerufen wird nach der Anmeldung, beim Start mit gespeichertem
 * Token und nach jedem Auffrischen; beim Abmelden `DELETE`.
 *
 * Nebenläufig und still: Ein Fehler hier darf die Anmeldung nie aufhalten — ohne Cookie fehlen im
 * schlimmsten Fall Bilder, solange die Route noch im Beobachtungsmodus läuft nicht einmal das.
 */
let synced: string | null = null;

export const syncFileSession = (accessToken: string | null): void => {
    if (typeof fetch === 'undefined' || accessToken === synced) return;
    synced = accessToken;
    const url = `${configuration.serverUrl}/auth/file-session`;
    const request: RequestInit = accessToken
        ? { method: 'POST', credentials: 'include', headers: { Authorization: `Bearer ${accessToken}` } }
        : { method: 'DELETE', credentials: 'include' };
    fetch(url, request).catch(() => {
        // Beim nächsten Token wieder versuchen.
        if (synced === accessToken) synced = null;
    });
};

/** Nur für Tests: den Merker zurücksetzen. */
export const resetFileSessionForTests = () => {
    synced = null;
};
